<template>
  <c-modal :value="true" hideCloseBtn persistent>
    <div class="text-center">
      <div class="heading-4 font-weight-medium">{{ title }}</div>
      <div class="mt-4 text-4 line-height-25 darkgray--text">{{ message }}</div>
      <div class="mt-5 text-4">
        <a
          v-if="!isDydx"
          :href="project.config.explorerTxsLink + txHash"
          target="_blank"
          rel="noopener noreferrer"
          class="text-decoration-none"
          >View Transaction</a
        >
        <a
          v-else
          :href="project.config.explorerBridgeLink + txHash"
          target="_blank"
          rel="noopener noreferrer"
          class="text-decoration-none"
          >View Transaction</a
        >
      </div>
    </div>
    <div class="mt-10 text-right">
      <c-btn @click="$emit('next')">Continue</c-btn>
    </div>
  </c-modal>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    title: {
      type: String,
      default: "Transaction sent",
    },
    message: {
      type: String,
      default:
        "Your transaction has been processed. You will be notified once it's confirmed.",
    },
    txHash: {
      type: String,
    },
    isDydx: {
      type: Boolean,
      default: false
    }
  },
  computed: mapGetters({
    project: "projectConfig/latestProject",
  }),
};
</script>